import { View, type ViewProps } from 'react-native'

export default function TabScreenContent({ children, style, ...props }: ViewProps) {
  return (
    <View {...props} style={[{ flex: 1 }, style]}>
      {children}
    </View>
  )
}
